import Modal from '@common/Modal'
import cn from './index.module.css'
import SecondaryButton from '@pages/Admin/CourseSettings/components/SecondaryButton/SecondaryButton'
import { useState } from 'react'
import CheckboxLabel from '@pages/Admin/CourseSettings/components/CheckboxLabel/CheckboxLabel'
import { CloseOutlined } from '@ant-design/icons'

const HideSupportModal = ({
  isVisible,
  onDismiss = () => {},
  onAction = () => {},
}: {
  isVisible: boolean
  onDismiss: () => void
  onAction: (save: boolean) => void
}) => {
  return (
    <Modal
      active={isVisible}
      setActive={onDismiss}
      // @ts-ignore
      className={cn.modalWrapper}
    >
      <ModalBody onAction={onAction} onDismiss={onDismiss} />
    </Modal>
  )
}

const ModalBody = ({
  onDismiss = () => {},
  onAction = () => {},
}: {
  onDismiss: () => void
  onAction: (save: boolean) => void
}) => {
  const [save, setSave] = useState(false)

  const onClick = () => {
    onAction(save)
  }

  return (
    <div className={cn.modalContainer}>
      <div className={cn.modalHeader}>
        <div className={cn.modalTitleContainer}>
          <span className={cn.modalHeaderTitle}>
            Отключить всплывающие подсказки?
          </span>
        </div>
        <CloseOutlined
          className={cn.closeIcon}
          onClick={onDismiss}
          onPointerEnterCapture={undefined}
          onPointerLeaveCapture={undefined}
        />
      </div>
      <div className={cn.formWrapper}>
        <CheckboxLabel
          value={save}
          onChange={setSave}
          label="Скрыть всплывающие подсказки"
        />
      </div>
      <div className={cn.footer}>
        <SecondaryButton onClick={onClick}>Скрыть</SecondaryButton>
      </div>
    </div>
  )
}

export default HideSupportModal
